import { ComponentProps } from "react";
import { useTranslation } from "react-i18next";
import { ColorSpinner, Flex, Text } from "shared/components/Spor";

export const LoadingContent = ({
  backgroundColor,
}: Pick<ComponentProps<typeof Flex>, "backgroundColor">) => {
  const { t } = useTranslation();

  return (
    <Flex
      width="100%"
      flex="1"
      flexDir="column"
      alignItems="center"
      justifyContent="center"
      backgroundColor={backgroundColor ?? "semantics.colorBackgroundSecondary"}
      gap="12px"
    >
      <ColorSpinner width="50px" />
      <Text my={0} textAlign="center" fontSize="sm">
        {t("Laster innhold")}
      </Text>
    </Flex>
  );
};
